// @flow
import type {DataTables} from 'datatables.net';

export default function rating(column: String, options: any, dtSettings: DataTables.Settings, component: JQuery) {
    dtSettings.columns.find(c => c.title == column).rating = (options == null ? true : options);
    $('body').on('mouseover', '.activity-rating-star', function () {
        $(this).addClass('selected')
        $(this).prevAll().addClass('selected')
    })

    $('body').on('mouseout', '.activity-rating-star', function () {
        $(this).removeClass('selected')
        $(this).prevAll().removeClass('selected')
    })
}